import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const permissions = initialState;

const slice = createSlice({
	name: "permissions",
	initialState,
	reducers: {
		setPermissions: (state, action) => {
			return action.payload;
		},
		updatePermissions: (state, action) => {
			state.permissions = [...action.payload];
			return state;
		}
	}
});

export const getPermissions = state => state.permissions;

export const { setPermissions, updatePermissions } = slice.actions;
export const selectPermissions = state => state.permissions;
export default slice.reducer;
